import type {SplitButtonOption} from "../../../general/SplitButton/index.ts";
import type {BalanceSheetExportFormat} from "../../../../generated/enums.ts";

export type ExportOption =
    | "collapsed"
    | "expanded"
    | "balance_sheet_pdf"
    | "balance_sheet_xlsx"
    | "json";

export type ExportAction =
    | {kind: "profit_and_loss_pdf"; expanded: boolean}
    | {kind: "balance_sheet"; format: BalanceSheetExportFormat}
    | {kind: "trial_balance_json"};

export interface ExportMenuOption extends SplitButtonOption {
    id: ExportOption;
}

export const EXPORT_STORAGE_KEY = "pocketcfo.profitAndLoss.pdfExportMode";

const EXPORT_ACTIONS: Record<ExportOption, ExportAction> = {
    collapsed: {kind: "profit_and_loss_pdf", expanded: false},
    expanded: {kind: "profit_and_loss_pdf", expanded: true},
    balance_sheet_pdf: {kind: "balance_sheet", format: "pdf"},
    balance_sheet_xlsx: {kind: "balance_sheet", format: "xlsx"},
    json: {kind: "trial_balance_json"},
};

const PROFIT_AND_LOSS_OPTIONS: ExportMenuOption[] = [
    {id: "collapsed", label: "W&V samengevat (PDF)"},
    {id: "expanded", label: "W&V uitgebreid (PDF)"},
];

const BALANCE_SHEET_OPTIONS: ExportMenuOption[] = [
    {id: "balance_sheet_pdf", label: "Balans (PDF)"},
    {id: "balance_sheet_xlsx", label: "Balans (Excel)"},
];

const TRIAL_BALANCE_JSON_OPTIONS: ExportMenuOption[] = [{id: "json", label: "JSON downloaden"}];

export function exportMenu(canExportProfitAndLoss: boolean, canExportTrialBalanceJson: boolean): ExportMenuOption[] {
    return [
        ...(canExportProfitAndLoss ? PROFIT_AND_LOSS_OPTIONS : []),
        ...BALANCE_SHEET_OPTIONS,
        ...(canExportTrialBalanceJson ? TRIAL_BALANCE_JSON_OPTIONS : []),
    ];
}

export function isExportOption(id: string): id is ExportOption {
    return Object.prototype.hasOwnProperty.call(EXPORT_ACTIONS, id);
}

export function exportActionFor(option: ExportOption): ExportAction {
    return EXPORT_ACTIONS[option];
}

export function exportButtonLabel(primaryLabel: string, selected: SplitButtonOption | undefined): string {
    return selected ? `${primaryLabel}: ${selected.label}` : primaryLabel;
}
